import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toImageUrl',
  standalone: true,
})
export class ToImageUrlPipe implements PipeTransform {
  transform(value: number[] | ArrayBuffer | string): string {
    if (!value) {
      return '';
    }

    if (value instanceof ArrayBuffer) {
      value = Array.from(new Uint8Array(value));
    }

    if (Array.isArray(value)) {
      const binaryString = value.reduce((acc: string, byte: number) => acc + String.fromCharCode(byte), '');
      const base64String = window.btoa(binaryString);
      return `data:image/jpeg;base64,${base64String}`;
    } else if (typeof value === 'string') {
      if (!value.startsWith('data:image/')) {
        return `data:image/jpeg;base64,${value}`;
      }
      return value;
    }

    return value;
  }
}
